export const TABLE_NAMESPACE = 'sdt';
